import { isSome } from '@mbfab/shared'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { useBackToList } from '@/components/app/use-back-to-list'
import { OrderMatchingNavigation } from '@/components/screens/order-line-matching/navigation'
import { OrderDetailContainer } from '@/components/screens/order-line-matching/order-detail-container'
import { ErrorPanel } from '@/components/ui/error-panel'
import { useMe } from '@/providers/me-context'

export const Route = createFileRoute('/t/$tenant_id/order_line_matching/orders/$order_id')({
  // 物件詳細から開いたときだけ物件キーが付き、戻り先とタブ表示をその画面に合わせる
  validateSearch: (search: Record<string, unknown>): { project?: string } => ({
    project: typeof search.project === 'string' && search.project !== '' ? search.project : undefined,
  }),
  component: Page,
})
function Page() {
  const { tenant_id: tenantId, order_id: orderId } = Route.useParams()
  const { project } = Route.useSearch()
  const me = useMe()
  const navigate = useNavigate()
  // 履歴があれば戻り（遷移元の物件詳細・発注書一覧の絞り込みを保つ）、無ければ遷移元に応じた画面へ移動する
  const backToList = useBackToList(() => {
    void navigate(
      isSome(project)
        ? {
            to: '/t/$tenant_id/order_line_matching/projects/$project_key',
            params: { tenant_id: tenantId, project_key: project },
          }
        : { to: '/t/$tenant_id/order_line_matching/orders', params: { tenant_id: tenantId } },
    )
  })
  return (
    <div className="flex min-h-screen bg-background">
      <AppSidebarContainer tenantId={tenantId} />
      <main className="min-w-0 flex-1 space-y-4 p-6">
        {me.tenant.setting?.orderLineMatchingEnabled === true ? (
          <>
            {!isSome(project) && <OrderMatchingNavigation tenantId={tenantId} value="orders" />}
            <OrderDetailContainer
              key={JSON.stringify([tenantId, orderId])}
              orderId={orderId}
              backLabel={isSome(project) ? '物件詳細' : undefined}
              onBack={backToList}
              canDelete
              onDeleted={() => {
                // 物件詳細から開いた場合、最後の発注を消すと物件ごと無くなるため物件詳細へは戻さず物件一覧へ移す
                void navigate(
                  isSome(project)
                    ? { to: '/t/$tenant_id/order_line_matching', params: { tenant_id: tenantId } }
                    : { to: '/t/$tenant_id/order_line_matching/orders', params: { tenant_id: tenantId } },
                )
              }}
            />
          </>
        ) : (
          <ErrorPanel
            layout="section"
            title="発注明細照合機能が有効になっていません"
            description="ご利用を希望する場合は運営までお問い合わせください。"
          />
        )}
      </main>
    </div>
  )
}
